import { render, staticRenderFns } from "./CardEditor.vue?vue&type=template&id=57beefca&scoped=true"
import script from "./CardEditor.vue?vue&type=script&lang=js"
export * from "./CardEditor.vue?vue&type=script&lang=js"
import style0 from "./CardEditor.vue?vue&type=style&index=0&id=57beefca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57beefca",
  null
  
)

export default component.exports